import DownloadsTemplate from "./DownloadsTemplate";

export default function AnnualReports() {
  const files = [
    {
      titleKey: "governance.annualReports.files.1.title",
      descKey: "governance.annualReports.files.1.desc",
      url: "#"
    }
  ];

  return (
    <DownloadsTemplate
      titleKey="governance.annualReports.title"
      descriptionKey="governance.annualReports.description"
      files={files}
      seoTitleKey="governance.annualReports.seo.title"
      seoDescKey="governance.annualReports.seo.description"
      seoPath="/governance/annual-reports"
    />
  );
}